module.exports = "img/button-text-underlined-on.f37818c.svg";